<div id="choose">



  <div class="option">
    <button class="optionB" (click)="fananPack()">

      <h5>Fanan Team Pro Pack</h5>

      <h6>price - 20$</h6>
    </button>
  </div>

  <div class="option">
    <button class="optionB" (click)="fananRoyalPack()">
      <h5>Fanan Team Royal Pack</h5>

      <h6>price - 30$</h6>

    </button>
  </div>

  <div class="option">
    <button class="optionB" (click)="cosmicPack()">
      <h5>Fanan team Cosmic Pack</h5>

      <h6>price - 17$</h6>

    </button>
  </div>

  <div class="option">
    <button class="optionB" (click)="galaDuo()">
      <h5>Fanan team Gala Duo</h5>

      <h6>price - 8$</h6>

    </button>
  </div>

  <div class="option">
    <button class="optionB" (click)="majoris()">
      <h5>Fanan team Majoris</h5>

      <h6>price - 8$</h6>

    </button>
  </div>

  <div class="option">
    <button class="optionB" (click)="sultana()">
      <h5>Fanan team Sultana</h5>

      <h6>price - 25$</h6>

    </button>
  </div>


</div>
